import {
  ACCOUNTANT,
  ADMIN,
  CASHIER,
  DELIVERY_PERSONNEL,
  INVENTORY_MANAGER,
  MANAGER,
  SALES_EXECUTIVE,
} from "./constant";

export const optionsForExpenseCategory = [
  { label: "Salary", value: "salary" },
  { label: "Office Expense", value: "office_Expense" },
  { label: "Rent", value: "rent" },
  { label: "EMI", value: "emi" },
  { label: "Utility", value: "utility" },
  { label: "Marketing", value: "marketing" },
  { label: "Transport", value: "transport" },
  { label: "Advertising", value: "advertising" },
  { label: "Eb-bill", value: "eb-bill" },
  { label: "Other", value: "other" },
];

export const optionsForModeOfPayment = [
  { label: "Cash", value: "cash" },
  { label: "Cheque", value: "cheque" },
  { label: "UPI", value: "upi" },
  { label: "Online", value: "online" },
];

export const optionsForTransactionType = [
  { label: "Cash In", value: "cash_in" },
  { label: "Cash Out", value: "cash_out" },
];

export const optionsForProductCategory = [
  { label: "A", value: "a" },
  { label: "A1", value: "a1" },
  { label: "B1", value: "b1" },
];

export const OptionsForItemReturnPeriod = [
  { label: "15 Days", value: "15_days", days: 15 },
  { label: "7 Days", value: "7_days", days: 7 },
  { label: "30 Days", value: "30_days", days: 30 },
];

export const optionsForServiceCategory = [
  { label: "Salon", value: "salon" },
  { label: "Spa", value: "spa" },
  { label: "Inrerior", value: "inrerior" },
  { label: "Catering", value: "catering" },
  { label: "Other", value: "other" },
];

export const optionsForServiceStatus = [
  { label: "Started", value: "started" },
  { label: "In-progress", value: "in-progress" },
  { label: "Completed", value: "completed" },
  { label: "Other", value: "other" },
];

export const optionsForTransactionStatus = [
  { label: "Not Paid", value: "not_paid" },
  { label: "Paid", value: "paid" },
  { label: "Partialy-paid", value: "partialy-paid" },
  { label: "Advance", value: "Advance" },
];
export const optionsForTransactionFilter = [
  { label: "Paid", value: "paid" },
  { label: "Pending", value: "pending_sale" },
  { label: "Partialy-paid", value: "partialy-paid" },
];
export const optionsForOrderStatus = [
  { label: "Drafted", value: "ordered" },
  { label: "Approved", value: "approved" },
  // { label: "Received", value: "received" },
  { label: "Shipped", value: "shipped" },
];
export const optionsForPerferedCommunication = [
  { label: "Email", value: "email" },
  { label: "Phone", value: "phone" },
];

export const optionsForGender = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "other" },
];

export const optionsForAccountCategory = [
  { label: "Savings", value: "savings" },
  { label: "Current", value: "current" },
];
export const optionsForSalaryFrequency = [
  { label: "Monthly", value: "monthly" },
  { label: "Weekly", value: "weekly" },
  { label: "Daily", value: "daily" },
];
export const optionsForIdProof = [
  { label: "Aadhar card", value: "aadhar_card" },
  { label: "Pan Card", value: "pan_card" },
  { label: "Voter I'd Card", value: "voter_id_card" },
];

export const optionsForPosition = [
  { label: "Manager", value: MANAGER, color: "text-blue-500" },
  { label: "Cashier", value: CASHIER, color: "text-green-500" },
  {
    label: "Inventory Manager",
    value: INVENTORY_MANAGER,
    color: "text-yellow-500",
  },
  {
    label: "Sales Executive",
    value: SALES_EXECUTIVE,
    color: "text-purple-500",
  },
  { label: "Accountant", value: ACCOUNTANT, color: "text-red-500" },
  {
    label: "Delivery Personnel",
    value: DELIVERY_PERSONNEL,
    color: "text-orange-500",
  },
  { label: "Admin", value: ADMIN, color: "text-indigo-500" },
  { label: "Other", value: "other", color: "text-gray-500" },
];
export const optionsForEmployeeType = [
  { value: "full_time", label: "Full Time" },
  { value: "part_time", label: "Part Time" },
];
export const optionsForwageRate = [
  { label: "Hourly", value: "Hourly" },
  { label: "Daily", value: "Daily" },
  { label: "Weekly", value: "Weekly" },
  { label: "Biweekly", value: "Biweekly" },
  { label: "Monthly", value: "Monthly" },
];

export const paymentStatusOptions = [
  { label: "Pending", value: "pending", color: "text-yellow-500" },
  { label: "Approved", value: "approved", color: "text-green-500" },
  { label: "Rejected", value: "rejected", color: "text-red-500" },
  {
    label: "Pending Approval",
    value: "pending_approval",
    color: "text-orange-500",
  },
  {
    label: "Approved and Paid",
    value: "approved_&_paid",
    color: "text-green-500",
  },
  {
    label: "Approved and Pending Payment",
    value: "approved_pending_payment",
    color: "text-green-500",
  },
  // { label: "Other", value: "Other", color: "text-gray-500" },
];

export const optionsForUnitSize = [
  { label: "BAGS(BAG)", value: "BAG" },
  { label: "BALE(BAL)", value: "BAL" },
  { label: "BUNDLES(BDL)", value: "BDL" },
  { label: "BUCKLES(BKL)", value: "BKL" },
  { label: "BILLION OF UNITS(BOU)", value: "BOU" },
  { label: "BOX(BOX)", value: "BOX" },
  { label: "BOTTLES(BTL)", value: "BTL" },
  { label: "BUNCHES(BUN)", value: "BUN" },
  { label: "CANS(CAN)", value: "CAN" },
  { label: "CUBIC METERS(CBM)", value: "CBM" },
  { label: "CUBIC CENTIMETERS(CCM)", value: "CCM" },
  { label: "CENTI METERS(CMS)", value: "CMS" },
  { label: "CARTONS(CTN)", value: "CTN" },
  { label: "DOZENS(DOZ)", value: "DOZ" },
  { label: "DRUMS(DRM)", value: "DRM" },
  { label: "GREAT GROSS(GGK)", value: "GGK" },
  { label: "GRAMMES(GMS)", value: "GMS" },
  { label: "GROSS(GRS)", value: "GRS" },
  { label: "GROSS YARDS(GYD)", value: "GYD" },
  { label: "KILOGRAMS(KGS)", value: "KGS" },
  { label: "KILOLITRE(KLR)", value: "KLR" },
  { label: "KILOMETRE(KME)", value: "KME" },
  { label: "LITRES(LTR)", value: "LTR" },
  { label: "METERS(MTR)", value: "MTR" },
  { label: "MILLILITRE(MLT)", value: "MLT" },
  { label: "METRIC TON(MTS)", value: "MTS" },
  { label: "NUMBERS(NOS)", value: "NOS" },
  { label: "OTHERS(OTH)", value: "OTH" },
  { label: "PACKS(PAC)", value: "PAC" },
  { label: "PIECES(PCS)", value: "PCS" },
  { label: "PAIRS(PRS)", value: "PRS" },
  { label: "QUINTAL(QTL)", value: "QTL" },
  { label: "ROLLS(ROL)", value: "ROL" },
  { label: "SETS(SET)", value: "SET" },
  { label: "SQUARE FEET(SQF)", value: "SQF" },
  { label: "SQUARE METERS(SQM)", value: "SQM" },
  { label: "SQUARE YARDS(SQY)", value: "SQY" },
  { label: "TABLETS(TBS)", value: "TBS" },
  { label: "TEN GROSS(TGM)", value: "TGM" },
  { label: "THOUSANDS(THD)", value: "THD" },
  { label: "TONNES(TON)", value: "TON" },
  { label: "TUBES(TUB)", value: "TUB" },
  { label: "US GALLONS(UGS)", value: "UGS" },
  { label: "UNITS(UNT)", value: "UNT" },
  { label: "YARDS(YDS)", value: "YDS" },
];
export const optionsForAgeGroup = [
  { label: "Child (0-12)", value: "child" },
  { label: "Teen (13-17)", value: "teen" },
  { label: "Adult (18-64)", value: "adult" },
  { label: "Senior (65+)", value: "senior" },
];
export const optionsForSubscription = (data) => {
  if (!data || !Array.isArray(data)) {
    return [];
  }

  const transformedData = data.map((item) => ({
    label: item?.frequency?.charAt(0).toUpperCase() + item?.frequency?.slice(1),
    value: item?.frequency,
  }));

  transformedData.unshift({ label: "No select", value: "" });

  return transformedData;
};

export const optionsForMonthIndex = [
  { label: "January", value: 0 },
  { label: "February", value: 1 },
  { label: "March", value: 2 },
  { label: "April", value: 3 },
  { label: "May", value: 4 },
  { label: "June", value: 5 },
  { label: "July", value: 6 },
  { label: "August", value: 7 },
  { label: "September", value: 8 },
  { label: "October", value: 9 },
  { label: "November", value: 10 },
  { label: "December", value: 11 },
];

export const optionsForTaxable = [
  { label: "Non-GST", value: "non-gst" },
  { label: "Exempt", value: "exempt" },
  { label: "Nil Rated", value: "nil_rated" },
  { label: "Taxable", value: "taxable" },
];

export const optionsForCustomertype = [
  { label: "Consumer", value: "consumer" },
  { label: "Business", value: "Business" },
];

export const optionsForExpenseTax = [
  {
    label: "No",
    value: "no_tax",
  },
  {
    label: "Yes",
    value: "taxable",
  },
];

export const optionsForBusinessCategory = [
  { label: "Select your business category", value: "no_select" },
  { label: "Clothing", value: "Clothing" },
  { label: "Medicine", value: "Medicine" },
  { label: "Grocery", value: "Grocery" },
  { label: "Salon", value: "Salon" },
  { label: "Gym", value: "Gym" },
  { label: "Restaurant", value: "Restaurant" },
  { label: "Other", value: "Other" },
];

export const optionsForCurrency = [
  { label: "₹", value: "₹" },
  { label: "$", value: " $ " },
  { label: "€", value: "€" },
  { label: "£", value: "£" },
  { label: "¥", value: "¥" },
];

export const generateOptionsForSubstitute = (products) => {
  if (!products || !Array.isArray(products)) return [];

  return [
    { label: "Select substitute product", value: "no-select" },
    ...products
      .filter(
        (product) =>
          product && (product.productName || product.rawMaterialName),
      )
      .map((product) => ({
        label: `${product.productName || product.rawMaterialName}${product.batchNumber ? ` (Batch: ${product.batchNumber})` : ""}`,
        // value: product.productId || product.rawMaterialId,
        value: String(product.productId || product.rawMaterialId),
        product: product,
      })),
  ];
};

export const frequencies = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "yearly", label: "Yearly" },
];
export const Expensefrequencies = [
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "yearly", label: "Yearly" },
];

export const searchOptionsSale = [
  { value: "productSubCategory", label: "Select Product Subcategory" },
  { value: "productCategory", label: "Select Product Category" },
  { value: "productName", label: "Select Product Name" },
  { value: "brandName", label: "Select Brand Name" },
  { value: "batchNumber", label: "Select Batch Number" },
  { value: "mfgDate", label: "Select Manufacturing Date" },
  { value: "expDate", label: "Select Expiry Date" },
  // { value: "", label: "Restart" },
];
export const searchOptions = [
  { value: "customerName", label: "Customer Name" },
  { value: "mobile", label: "Customer Mobile" },
];

export const optionsForModeOfPaymentAll = [
  { label: "All", value: "" },
  { label: "Cash", value: "cash" },
  { label: "Cheque", value: "cheque" },
  { label: "UPI", value: "upi" },
  { label: "Online", value: "online" },
];
export const optionsForExpenseCategoryvalue = [
  { label: "All", value: "" },
  { label: "Salary", value: "salary" },
  { label: "Office Expense", value: "office_Expense" },
  { label: "Rent", value: "rent" },
  { label: "EMI", value: "emi" },
  { label: "Utility", value: "utility" },
  { label: "Other", value: "other" },
];

export const expensepaymentStatusOptions = [
  { label: "All", value: "" },
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
  { label: "Rejected", value: "rejected" },
  { label: "Pending Approval", value: "pending_approval" },
  { label: "Approved and Paid", value: "approved_&_paid" },
  { label: "Approved and Pending Payment", value: "approved_pending_payment" },
  { label: "Other", value: "Other" },
];

export const reportData = [
  { label: "All Data", value: "Total Data" },
  { value: "Today", label: "Added today" },
  { value: "Weekly", label: "last Week data" },
  { value: "Monthly", label: "last Month data" },
  { value: "6 Months", label: "last 6 Month" },
  { value: "1 Year", label: "last 1 Year" },
  { value: "2 Years", label: "last 2 Years" },
  { value: "Other", label: "Other" },
];
export const reportpnlData = [
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
  { label: "Yearly", value: "yearly" },
  { value: "Other", label: "Other" },
];
export const PendingData = [
  { label: "All pending payments", value: "Total Data" },
  { value: "Today", label: "Added today" },
  { value: "Weekly", label: "last Week data" },
  { value: "Monthly", label: "last Month data" },
  { value: "6 Months", label: "last 6 Month" },
  { value: "1 Year", label: "last 1 Year" },
  // { value: "2 Years", label: "last 2 Years" },
  { value: "Other", label: "Other" },
];

export const optionForinventory = [
  { value: "Category", label: " Category" },
  { value: "Subcategory", label: " Subcategory" },
  { value: "EAN Number", label: " EAN Number" },
  { value: "Batch Number", label: " Batch Number" },
  { value: "Mfg Date", label: " Mfg Date" },
  { value: "Exp Date", label: " Exp Date" },
  { value: "Opening Stock", label: " Opening Stock" },
  { value: "Brand Name", label: " Brand Name" },
];

export const optionForSelectinventory = [
  { value: "Subcategory", label: "Subcategory" },
  { value: "Category", label: "Category" },
  { value: "Brand Name", label: "Brand Name" },
  { value: "Batch Number", label: "Batch Number" },
  { value: "Manufacturing Date", label: "Manufacturing Date" },
  { value: "Expiry Date", label: "Expiry Date" },
  { value: "", label: "Product Name" },
];

export const optionsForSupplierType = [
  { value: "registered", label: "Registered" },
  { value: "unregistered", label: "Unregistered" },
];

export const optionsForIncomeType = [
  { label: "Direct", value: "Direct" },
  { label: "InDirect", value: "InDirect" },
];
export const optionsForIncomeCategory = [
  { label: "Sales", value: "sales" },
  { label: "Interest Income", value: "interest_income" },
  { label: "Rental Income", value: "rental_income" },
  { label: "Commission", value: "commission" },
  { label: "Consulting Fees", value: "consulting_fees" },
  { label: "Other Income", value: "other" },
];

export const optionsForCustomerOrSupplier = [
  { label: "Issued to Customer", value: "customer" },
  { label: "Received from Supplier", value: "supplier" },
];
export const optionsForNoteType = [
  { label: "Debit", value: "debit" },
  { label: "Credit", value: "credit" },
];
export const optionsForIssueOrrevive = [
  { label: "Issue", value: "issue" },
  { label: "Receive", value: "receive" },
];
export const frequencyOptions = [
  { value: "", label: "Select Frequency", disabled: true },
  { label: "Daily", value: "daily" },
  { label: "Weekly", value: "weekly" },
  { label: "Bi-Weekly (Every 2 weeks)", value: "bi-weekly" },
  { label: "Monthly", value: "monthly" },
  { label: "Bi-Monthly (Twice a month)", value: "bi-monthly" },
  { label: "Every 2 Months", value: "2-months" },
  { label: "Every 4 Months", value: "4-months" },
  { label: "Every 6 Months", value: "6-months" },
];
export const optionsForSaleType = [
  { label: "Confirm Sale", value: "confirmSale" },
  { label: "Estimate", value: "estimate" },
  { label: "Advance Payment", value: "advancePayment" },
  // { label: "Advance Sale", value: "advanceSale" },
];
export const optionsForSaleTypeWithAdvance = [
  { label: "Advance Payment", value: "advancePayment" },
  { label: "Advance Sale", value: "advanceSale" },
];
export const optionsForDeliveryType = [
  { label: "Takeout", value: "takeout" },
  {
    label: "Schedule Pickup",
    value: "shedulePickup",
  },
  { label: "Home Delivery", value: "homeDelivery" },
];
export const optionsForFontCategory = [
  { label: "Arial (sans-serif)", value: "Arial, sans-serif" },
  { label: "Arial Black (sans-serif)", value: "Arial Black, sans-serif" },
  { label: "Helvetica (sans-serif)", value: "Helvetica, sans-serif" },
  { label: "Verdana (sans-serif)", value: "Verdana, sans-serif" },
  { label: "Tahoma (sans-serif)", value: "Tahoma, sans-serif" },
  { label: "Trebuchet MS (sans-serif)", value: "Trebuchet MS, sans-serif" },
  { label: "Impact (sans-serif)", value: "Impact, sans-serif" },
  { label: "Gill Sans (sans-serif)", value: "Gill Sans, sans-serif" },

  // Serif fonts
  { label: "Times New Roman (serif)", value: "Times New Roman, serif" },
  { label: "Georgia (serif)", value: "Georgia, serif" },
  { label: "Palatino (serif)", value: "Palatino, serif" },
  { label: "Baskerville (serif)", value: "Baskerville, serif" },

  // Monospace fonts
  { label: "Andalé Mono (monospace)", value: "Andalé Mono, monospace" },
  { label: "Courier (monospace)", value: "Courier, monospace" },
  { label: "Lucida (monospace)", value: "Lucida, monospace" },
  { label: "Monaco (monospace)", value: "Monaco, monospace" },

  // Cursive fonts
  { label: "Bradley Hand (cursive)", value: "Bradley Hand, cursive" },
  { label: "Brush Script MT (cursive)", value: "Brush Script MT, cursive" },
  { label: "Comic Sans MS (cursive)", value: "Comic Sans MS, cursive" },

  // Fantasy fonts
  { label: "Luminari (fantasy)", value: "Luminari, fantasy" },

  // Custom 3D fonts
  // { label: "3D Shadow", value: "3d-shadow" },
  // { label: "Inset Text", value: "inset-text" },
];
export const colors = [
  "#FF5733",
  "#33FF57",
  "#3357FF",
  "#FF33A1",
  "#A133FF",
  "#FF33F4",
  "#33FFF8",
  "#F4FF33",
  "#FF8333",
  "#F9FF33",
  "#FFC300",
  "#DAF7A6",
  "#581845",
  "#900C3F",
  "#C70039",
  "#FF5733",
  "#FFBD33",
  "#C9A1FF",
  "#FF59B7",
  "#D6D1FF",
];

export const gradients = [
  {
    color: "linear-gradient(to right, #FF7E5F, #FEB47B)",
    colors: ["#FF7E5F", "#FEB47B"],
  },
  {
    color: "linear-gradient(to right, #6a11cb, #2575fc)",
    colors: ["#6a11cb", "#2575fc"],
  },
  {
    color: "linear-gradient(to right, #00c6ff, #0072ff)",
    colors: ["#00c6ff", "#0072ff"],
  },
  {
    color: "linear-gradient(to right, #ff6a00, #ee0979)",
    colors: ["#ff6a00", "#ee0979"],
  },
  {
    color: "linear-gradient(to right, #ff512f, #dd2476)",
    colors: ["#ff512f", "#dd2476"],
  },
  {
    color: "linear-gradient(to right, #fbc2eb, #a6c1ee)",
    colors: ["#fbc2eb", "#a6c1ee"],
  },
  {
    color: "linear-gradient(to right, #ff5f6d, #ffc371)",
    colors: ["#ff5f6d", "#ffc371"],
  },
  {
    color: "linear-gradient(to right, #6a11cb, #2575fc)",
    colors: ["#6a11cb", "#2575fc"],
  },
  {
    color: "linear-gradient(to right, #00c6ff, #0072ff)",
    colors: ["#00c6ff", "#0072ff"],
  },
  {
    color: "linear-gradient(to right, #f6d365, #fda085)",
    colors: ["#f6d365", "#fda085"],
  },
  // Additional light gradients
  {
    color: "linear-gradient(to right, #FFB88C, #FDCB82)",
    colors: ["#FFB88C", "#FDCB82"],
  },
  {
    color: "linear-gradient(to right, #FFCCBC, #D5E1DF)",
    colors: ["#FFCCBC", "#D5E1DF"],
  },
  {
    color: "linear-gradient(to right, #FFEFD5, #FFE3E3)",
    colors: ["#FFEFD5", "#FFE3E3"],
  },
  {
    color: "linear-gradient(to right, #F9FBCB, #E9E4D4)",
    colors: ["#F9FBCB", "#E9E4D4"],
  },
  {
    color: "linear-gradient(to right, #A2C2E8, #F1D6E0)",
    colors: ["#A2C2E8", "#F1D6E0"],
  },
  {
    color: "linear-gradient(to right, #E0C3FC, #8EABFF)",
    colors: ["#E0C3FC", "#8EABFF"],
  },
  {
    color: "linear-gradient(to right, #FFE5B4, #FFD9E8)",
    colors: ["#FFE5B4", "#FFD9E8"],
  },
  {
    color: "linear-gradient(to right, #D4E157, #B8E1F4)",
    colors: ["#D4E157", "#B8E1F4"],
  },
  {
    color: "linear-gradient(to right, #FFABAB, #FFC3A0)",
    colors: ["#FFABAB", "#FFC3A0"],
  },
  {
    color: "linear-gradient(to right, #D4A5A5, #F6AAB6)",
    colors: ["#D4A5A5", "#F6AAB6"],
  },
];

export const modalContent = [
  {
    id: "default",
    // component: newProductImage, // Default image or your custom component
    title: "Make Your Own",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/newProduct.png",
    className: "bg-white p-6 rounded-lg",
  },
  {
    id: "gradientBackground",
    // component: ImageOne,
    title: "Gradient Background",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/gradient-background.jpg",
  },
  {
    id: "pexelsImage1",
    // component: ImageTwo,
    title: "Pexels Image 1",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/pexels.jpg",
  },
  {
    id: "pexelsImage2",
    // component: ImageThree,
    title: "Pexels Image 2",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/pexels-ann.jpg",
  },
  {
    id: "pexelsImage3",
    // component: ImageFour,
    title: "Pexels Image 3",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-codioful.jpg",
  },
  {
    id: "pexelsImage4",
    // component: ImageFive,
    title: "Pexels Image 4",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-george-dolgikh.jpg",
  },
  {
    id: "pexelsImage5",
    // component: ImageSix,
    title: "Pexels Image 5",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-jessbaileydesign.jpg",
  },
  {
    id: "pexelsImage6",
    // component: ImageEight,
    title: "Pexels Image 6",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/pexels-lum.jpg",
  },
  {
    id: "pexelsImage7",
    // component: ImageNine,
    title: "Pexels Image 7",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/pexels-moose.jpg",
  },
  {
    id: "pexelsImage8",
    // component: ImageTen,
    title: "Pexels Image 8",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-padrinan.jpg",
  },
  {
    id: "pexelsImage9",
    // component: ImageEle,
    title: "Pexels Image 9",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-padrinan-1111369.jpg",
  },
  {
    id: "pexelsImage10",
    // component: ImageTwel,
    title: "Pexels Image 10",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/pexels-pixabay.jpg",
  },
  {
    id: "pexelsImage11",
    // component: ImageThrtn,
    title: "Pexels Image 11",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-poppythomashill.jpg",
  },
  {
    id: "pexelsImage12",
    // component: ImageFoutn,
    title: "Pexels Image 12",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-tirachard-kumtanom.jpg",
  },
  {
    id: "upgrade",
    // component: ImageFiftn,
    title: "Upgrade",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/upgrapg.jpg",
  },
  {
    id: "newProduct",
    // component: newProductImage,
    title: "New Product",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/newProduct.png",
  },
  {
    id: "freebie",
    // component: freebieimage,
    title: "Freebie",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/freebie.png",
  },
  {
    id: "flatDiscount",
    // component: flatdiscount,
    title: "Flat Discount",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/flatdiscount.png",
  },
  {
    id: "megaSale",
    // component: megasaleImg,
    title: "Mega Sale",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/megasale.png",
  },
  {
    id: "seasonal",
    // component: seasonalimage,
    title: "Seasonal",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/seasonal.png",
  },
  {
    id: "specialOffer",
    // component: specialofferimage,
    title: "Special Offer",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/specialoffer.png",
  },
  {
    id: "thankYou",
    // component: thankyouimage,
    title: "Thank You",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/thankyou.png",
  },
  {
    id: "weMissYou",
    // component: wemissyou,
    title: "We Miss You",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/wemissyou.png",
  },
  {
    id: "slImage1",
    // component: ImageTwentytwo,
    title: "SL Image 1",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/sl_070622_51410_32.jpg",
  },
  {
    id: "slImage2",
    // component: ImageTwentythree,
    title: "SL Image 2",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/sl_062022_51020_46.jpg",
  },
  {
    id: "slImage3",
    // component: ImageTwentyfour,
    title: "SL Image 3",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/sl_062022_51020_39.jpg",
  },
  {
    id: "adhwaithImage",
    // component: ImageTwentyfive,
    title: "Adhwaith Image",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-adhwaith.jpg",
  },
  {
    id: "boxWriteInIt",
    // component: ImageTwentysix,
    title: "Box Write In It",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/box-write-in-it-5279529_640.jpg",
  },
  {
    id: "natureImage",
    // component: ImageTwentyseveneight,
    title: "Nature Image",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/3983183.jpg",
  },
  {
    id: "mountainImage",
    // component: ImageTwentynine,
    title: "Mountain Image",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/1562.jpg",
  },
  {
    id: "vintageImage",
    // component: ImageTwentyten,
    title: "Vintage Image",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/1559.jpg",
  },
  {
    id: "pexelsImage13",
    // component: ImageThirty,
    title: "Pexels Image 13",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/1550.jpg",
  },
  {
    id: "pexelsImage14",
    // component: ImageThirtyone,
    title: "Pexels Image 14",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/1548.jpg",
  },
  {
    id: "PexelsImage15",
    // component: ImageThirtytwo,
    title: "Pexels Image 15",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/1104.jpg",
  },
  {
    id: "pexelsImage16",
    // component: ImageThirtythree,
    title: "Pexels Image 16",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/887.jpg",
  },
  {
    id: "vintageImage2",
    // component: ImageThirtyforty,
    title: "Vintage Image 2",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5625130.jpg",
  },
  {
    id: "imageSixtn",
    // component: ImageSixtn,
    title: "Image 16",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/Pngtree.png",
  },
  {
    id: "imageSeventn",
    // component: ImageSeventn,
    title: "Image 17",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/Pngtreblue.png",
  },
  {
    id: "imageEighttb",
    // component: ImageEighttb,
    title: "Image 18",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/piyush5.jpg",
  },
  {
    id: "imageNinetn",
    // component: ImageNinetn,
    title: "Image 19",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/v915-wit.jpg",
  },
  {
    id: "imageTwenty",
    // component: ImageTwenty,
    title: "Image 20",
    coverPhoto: "https://dukaanbuddyassets.s3.amazonaws.com/v906-gib-0030c.jpg",
  },
  {
    id: "imageThirtyfifty",
    // component: ImageThirtyfifty,
    title: "Image 35",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5625130.jpg",
  },
  {
    id: "imageThirtysixty",
    // component: ImageThirtysixty,
    title: "Image 36",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-max-fischer-5872364.jpg",
  },
  {
    id: "imageThirtyseventy",
    // component: ImageThirtyseventy,
    title: "Image 37",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5625047.jpg",
  },
  {
    id: "imageThirtyeight",
    // component: ImageThirtyeight,
    title: "Image 38",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5624998.jpg",
  },
  {
    id: "imageThirtynine",
    // component: ImageThirtynine,
    title: "Image 39",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5625126.jpg",
  },
  {
    id: "imageFourty",
    // component: ImageFourty,
    title: "Image 40",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5625061.jpg",
  },
  {
    id: "imageFourtyOne",
    // component: ImageFourtyOne,
    title: "Image 41",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5632398.jpg",
  },
  {
    id: "imageFourtytwo",
    // component: ImageFourtytwo,
    title: "Image 42",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5632334.jpg",
  },
  {
    id: "imageFourtythree",
    // component: ImageFourtythree,
    title: "Image 43",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-n-voitkevich-6214383.jpg",
  },
  {
    id: "imageFourtyfour",
    // component: ImageFourtyfour,
    title: "Image 44",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5650017.jpg",
  },
  {
    id: "imageFourtyfive",
    // component: ImageFourtyfive,
    title: "Image 45",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-max-fischer-5872357.jpg",
  },
  {
    id: "imageFourtysix",
    // component: ImageFourtysix,
    title: "Image 46",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5650027.jpg",
  },
  {
    id: "imageFourtyseven",
    // component: ImageFourtyseven,
    title: "Image 47",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5650043.jpg",
  },
  {
    id: "imageFourtyeight",
    // component: ImageFourtyeight,
    title: "Image 48",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-thirdman-5767378.jpg",
  },
  {
    id: "imageFourtynine",
    // component: ImageFourtynine,
    title: "Image 49",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5625036.jpg",
  },
  {
    id: "fifty",
    // component: Fifty,
    title: "Image 50",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-max-fischer-5872303.jpg",
  },
  {
    id: "fiftyone",
    // component: Fiftyone,
    title: "Image 51",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-pavel-danilyuk-8638298.jpg",
  },
  {
    id: "fiftytwo",
    // component: Fiftytwo,
    title: "Image 52",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-pavel-danilyuk-8638307.jpg",
  },
  {
    id: "fiftythree",
    // component: Fiftythree,
    title: "Image 53",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-karolina-grabowska-5650037.jpg",
  },
  {
    id: "fiftyfour",
    // component: Fiftyfour,
    title: "Image 54",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-vie-studio-4439456.jpg",
  },
  {
    id: "fiftyfive",
    // component: Fiftyfive,
    title: "Image 55",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-cottonbro-6114597.jpg",
  },
  {
    id: "fiftysix",
    // component: Fiftysix,
    title: "Image 56",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-boris-pavlikovsky-5498382.jpg",
  },
  {
    id: "fiftyseven",
    // component: FiftySeven,
    title: "Image 57",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-rdne-7563560.jpg",
  },
  {
    id: "fiftyeight",
    // component: Fiftyeight,
    title: "Image 58",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-anna-nekrashevich-8534381.jpg",
  },
  {
    id: "fiftynine",
    // component: Fiftynine,
    title: "Image 59",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-anna-nekrashevich-8534233.jpg",
  },
  {
    id: "sixty",
    // component: SIxty,
    title: "Image 60",
    coverPhoto:
      "https://dukaanbuddyassets.s3.amazonaws.com/pexels-gaurav-kumar-1281378-18488298.jpg",
  },
];
// export const getCurrencySymbol = (currency) => {
//   switch (currency) {
//     case 'INR':
//       return '₹';
//     case 'USD':
//       return '$';
//     case 'EUR':
//       return '€';
//     case 'GBP':
//       return '£';
//     case 'JPY':
//       return '¥';
//     default:
//       return '';
//   }

// }

export const CurrencySymbols = [
  { value: "INR", label: "INR" },
  { value: "USD", label: "USD" },
  { value: "EUR", label: "EUR" },
  { value: "GBP", label: "GBP" },
  { value: "JPY", label: "JPY" },
];
export const getCurrencySymbol = (currency) => {
  switch (currency) {
    case "INR":
      return "₹";
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    case "JPY":
      return "¥";
    default:
      return "";
  }
};

export const subSupplyTypeOption = [
  { label: "Supply", value: "1" },
  { label: "Import", value: "2" },
  { label: "Export", value: "3" },
  { label: "Job Work", value: "4" },
  { label: "For Own Use", value: "5" },
  { label: "Job work Returns", value: "6" },
  { label: "Sales Return", value: "7" },
  { label: "Others", value: "8" },
  { label: "SKD/CKD/Lots", value: "9" },
  { label: "Line Sales", value: "10" },
  { label: "Recipient Not Known", value: "11" },
  { label: "Exhibition or Fairs", value: "12" },
];

export const transportationModeOptions = [
  { label: "Road", value: "1" },
  { label: "Rail", value: "2" },
  { label: "Air", value: "3" },
  { label: "Ship", value: "4" },
  { label: "In Transit", value: "5" },
];
export const optionsForProductionStatus = [
  { value: "planned", label: "Planned" },
  { value: "in-progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
  { value: "on-hold", label: "On Hold" },
  { value: "cancelled", label: "Cancelled" },
  { value: "delayed", label: "Delayed" },
];

export const optionsForPriority = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" },
];
export const optionsForDiscountUnit = [
  { label: "₹", value: "₹" },
  { label: "%", value: "%" },
];
export const STATE_CODE_MAP = {
  "Andhra Pradesh": "AP",
  "Arunachal Pradesh": "AR",
  Assam: "AS",
  Bihar: "BR",
  Chhattisgarh: "CG",
  Goa: "GA",
  Gujarat: "GJ",
  Haryana: "HR",
  "Himachal Pradesh": "HP",
  Jharkhand: "JH",
  Karnataka: "KA",
  Kerala: "KL",
  "Madhya Pradesh": "MP",
  Maharashtra: "MH",
  Manipur: "MN",
  Meghalaya: "ML",
  Mizoram: "MZ",
  Nagaland: "NL",
  Odisha: "OD",
  Punjab: "PB",
  Rajasthan: "RJ",
  Sikkim: "SK",
  "Tamil Nadu": "TN",
  Telangana: "TS",
  Tripura: "TR",
  "Uttar Pradesh": "UP",
  Uttarakhand: "UK",
  "West Bengal": "WB",
  Delhi: "DL",
};

export const apiProviders = [
  // {
  //   id: "track123",
  //   name: "Track123",
  //   description: "Track 1700+ carriers worldwide",
  // },
  {
    id: "shiprocket", // 🔁 renamed
    name: "ShipRocket",
    description: "ShipRocket logistics & order fulfillment",
  },
  // {
  //   id: "seventeentrack",
  //   name: "17TRACK",
  //   description: "Global tracking platform",
  // },
  // {
  //   id: "delhivery",
  //   name: "Delhivery API",
  //   description: "Direct Delhivery integration",
  // },
];
export const FeaturedSectionOptions = [
  { value: '📦', label: 'PRODUCT', translationKey: 'SETTINGS.PRODUCT' },
  { value: '🚚', label: 'DELIVERY', translationKey: 'SETTINGS.DELIVERY' },
  { value: '⭐', label: 'QUALITY', translationKey: 'SETTINGS.QUALITY' },
  { value: '💳', label: 'PAYMENT', translationKey: 'SETTINGS.PAYMENT' },
  { value: '🛡️', label: 'SECURITY', translationKey: 'SETTINGS.SECURITY' },
  { value: '📞', label: 'SUPPORT', translationKey: 'SETTINGS.SUPPORT' },
  { value: '💎', label: 'PREMIUM', translationKey: 'SETTINGS.PREMIUM' },
  { value: '⚡', label: 'FAST', translationKey: 'SETTINGS.FAST' },
];

export const QrSizeOptions = [
  { size: 128, label: "Small", translationKey: "SETTINGSS.SMALL" },
  { size: 256, label: "Medium", translationKey: "SETTINGSS.MEDIUM" },
  { size: 384, label: "Large", translationKey: "SETTINGSS.LARGE" }
];

export const AddressLabelOptions = [
  { value: "Home", label: "Home" },
  { value: "Work", label: "Work" },
  { value: "Other", label: "Other" }
];

export const getResellerOrderStatusOptions = (t) => [
  { value: "", label: t("RESELLER_ORDER.ALL_ORDERS") },
  { value: "pending", label: t("RESELLER_ORDER.PENDING") },
  { value: "confirmed", label: t("RESELLER_ORDER.CONFIRMED") },
  { value: "shipped", label: t("RESELLER_ORDER.SHIPPED") },
  { value: "delivered", label: t("RESELLER_ORDER.DELIVERED") },
  { value: "cancelled", label: t("RESELLER_ORDER.CANCELLED") },
];

export const allowedSellTypeOptions = [
  { value: "products", label: "Products Only" },
  { value: "services", label: "Services Only" },
  { value: "both", label: "Both" },
];

export const getPurchaseTypeOptions = (warehouseModule = false) => [
  { label: "Products Only", value: "products" },
  { label: "Services Only", value: "services" },
  ...(warehouseModule ? [{ label: "Raw Only", value: "raw" }] : []),
  { label: "Both", value: "both" },
];

export const inventoryApprovalOptions = [
  { value: "manual", label: "Manual" },
  { value: "auto", label: "Auto" },
];

export const getResellerOrdersStatusOptions = (t) => [
  { value: "", label: t("RESELLER_ORDERS.ALL_STATUS") },
  { value: "pending", label: t("RESELLER_ORDERS.PENDING") },
  { value: "confirmed", label: t("RESELLER_ORDERS.CONFIRMED") },
  { value: "shipped", label: t("RESELLER_ORDERS.SHIPPED") },
  { value: "delivered", label: t("RESELLER_ORDERS.DELIVERED") },
  { value: "cancelled", label: t("RESELLER_ORDERS.CANCELLED") },
];
export const employeType= (t) => [
                      { value: 'all', label: t('EMPLOYEEDASHBOARD.FILTERS.ALL_TYPES') },
                      { value: 'full_time', label: t('EMPLOYEEDASHBOARD.FILTERS.FULL_TIME') },
                      { value: 'part_time', label: t('EMPLOYEEDASHBOARD.FILTERS.PART_TIME') }
]
export const attendanceStatus = (t) => [
  { value: 'all', label: t('EMPLOYEEDASHBOARD.FILTERS.ALL_STATUS') },
  { value: 'present', label: t('EMPLOYEEDASHBOARD.ATTENDANCE.PRESENT') },
  { value: 'absent', label: t('EMPLOYEEDASHBOARD.ATTENDANCE.ABSENT') },
  { value: 'paidLeave', label: t('EMPLOYEEDASHBOARD.ATTENDANCE.ON_LEAVE') }
];